<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-5">
            <div class="mb-3">
                <h6 class="f-w-700 pb-1">Department Number : 10000</h6>
            </div>
        </div>
        <div class=" col-sm-7">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="show-on-menu" type="checkbox" value=""
                                v-model="compState.showOnMenu">
                            <label class="form-check-label" for="show-on-menu">Show on Menu</label>
                        </div>
                    </div>
                </div>
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="sele-department" type="checkbox" value=""
                                v-model="compState.saleDepartment">
                            <label class="form-check-label" for="sele-department">Sale Department</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-5">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Department Name</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" placeholder="Name" maxlength="32">
            </div>
        </div>
        <div class="col-sm-7">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternative Display Language</h6>
                </label>
                <input class="form-control" type="text" placeholder="Alternative Display Language"
                    v-model="compState.altLangText" maxlength="32" readonly data-bs-toggle="modal"
                    data-original-title="test" data-bs-target="#alt-lang-modal">
            </div>
        </div>
    </div>
    <div class="row ">
        <div class="col-sm-5">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Rate</h6>
                </label>
                <div class="input-group">
                    <select v-model="compState.taxRate" class="form-select" aria-label="Tax Rate">
                        <option value="">Tax Rate</option>
                        <option value="Tax">Tax</option>
                        <option value="Tax2">Tax2</option>
                        <option value="Tax3">Tax3</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class=" row mb-3">
        <div class=" col-5">
            <label>
                <h6 class="f-w-700">Display Order</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.displayOrder">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayOrderDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayOrderIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-7" style="margin-top: 30px;">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="service-check" type="checkbox" value=""
                                v-model="compState.nonDiscountable">
                            <label class="form-check-label" for="service-check">Non-Discountable</label>
                        </div>
                    </div>
                </div>
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="surchargeable-check" type="checkbox" value=""
                                v-model="compState.nonSurchargeable">
                            <label class="form-check-label" for="surchargeable-check">Non-Surchargeable</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-5 ">
            <div class=" checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="scale-check" type="checkbox" value=""
                        v-model="compState.scaleDepartment">
                    <label class="form-check-label" for="scale-check">Scale Department</label>
                </div>
            </div>
        </div>
        <div class="col-sm-7">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Unit of Sale</h6>
                </label>
                <div class="input-group">
                    <select class="form-select" aria-label="Tax Rate" v-model="compState.unitOfSale">
                        <option value="">Unit of Sale</option>
                        <option value="Individually">Individually</option>
                        <option value="Gram">Gram</option>
                        <option value="Kilogram">Kilogram</option>
                        <option value="Ounce">Ounce</option>
                        <option value="Pound">Pound</option>
                        <option value="Milliliter">Milliliter</option>
                        <option value="Liter">Liter</option>
                        <option value="Pint">Pint</option>
                        <option value="Quart">Quart</option>
                        <option value="Gallon">Gallon</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <departmentsAltLangModal @on-save="onEditAltLang" />
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useDepartmentsStore } from '@/store/management/departmentsStore';
import type { Department } from '@/store/management/departmentsStore';

const departmentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsAltLangModal.vue'))

const departmentsStore = useDepartmentsStore()

onMounted(() => {
    if (tempActiveDepartment.value?.id) {
        compState.id = tempActiveDepartment.value.id
        compState.name = tempActiveDepartment.value.name
        compState.showOnMenu = tempActiveDepartment.value.showOnMenu
        compState.saleDepartment = tempActiveDepartment.value.saleDepartment
        compState.taxRate = tempActiveDepartment.value.taxRate
        compState.displayOrder = tempActiveDepartment.value.displayOrder
        compState.nonDiscountable = tempActiveDepartment.value.nonDiscountable
        compState.nonSurchargeable = tempActiveDepartment.value.nonSurchargeable
        compState.scaleDepartment = tempActiveDepartment.value.scaleDepartment
        compState.unitOfSale = tempActiveDepartment.value.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
    console.log('tempActiveDepartment', tempActiveDepartment.value);

})

const compState = reactive({
    id: '',
    name: '',
    showOnMenu: false,
    saleDepartment: false,
    taxRate: '',
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    scaleDepartment: false,
    unitOfSale: '',
    altLangText: ''
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const activeDepartment = computed(() => {
    return departmentsStore.getActiveDepartment
})

const tempActiveDepartment = computed(() => {
    return departmentsStore.getTempActiveDepartment
})

const activeDepartmentId = computed(() => {
    return departmentsStore.getActiveDepartmentId
})

watch(activeDepartmentId, (newVal) => {
    if (newVal) {
        const department = activeDepartment.value
        compState.id = department.id
        compState.name = department.name
        compState.showOnMenu = department.showOnMenu
        compState.saleDepartment = department.saleDepartment
        compState.taxRate = department.taxRate
        compState.displayOrder = department.displayOrder
        compState.nonDiscountable = department.nonDiscountable
        compState.nonSurchargeable = department.nonSurchargeable
        compState.scaleDepartment = department.scaleDepartment
        compState.unitOfSale = department.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    departmentsStore.setTempActiveDepartment({
        ...tempActiveDepartment.value,
        id: newVal.id,
        name: newVal.name,
        showOnMenu: newVal.showOnMenu,
        saleDepartment: newVal.saleDepartment,
        taxRate: newVal.taxRate,
        displayOrder: newVal.displayOrder,
        nonDiscountable: newVal.nonDiscountable,
        nonSurchargeable: newVal.nonSurchargeable,
        scaleDepartment: newVal.scaleDepartment,
        unitOfSale: newVal.unitOfSale,
    } as Department)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
}
</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>